/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Window_Resize_TlInputs */

const en_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize from top-left`)
};

const ar_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الحجم من الزاوية العلوية اليسرى`)
};

const bn_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উপর-বাম থেকে রিসাইজ করুন`)
};

const de_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe von oben links ändern`)
};

const es_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tamaño desde arriba a la izquierda`)
};

const fr_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionner à partir du coin supérieur gauche`)
};

const pt_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar do canto superior esquerdo`)
};

const zh_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从左上角调整大小`)
};

const tr_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sol üstten yeniden boyutlandır`)
};

const ru_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение размера сверху слева`)
};

const pl_window_resize_tl = /** @type {(inputs: Window_Resize_TlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień rozmiar od lewego górnego rogu`)
};

/**
* | output |
* | --- |
* | "Resize from top-left" |
*
* @param {Window_Resize_TlInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const window_resize_tl = /** @type {((inputs?: Window_Resize_TlInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Window_Resize_TlInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_window_resize_tl(inputs)
	if (locale === "bn") return bn_window_resize_tl(inputs)
	if (locale === "de") return de_window_resize_tl(inputs)
	if (locale === "es") return es_window_resize_tl(inputs)
	if (locale === "fr") return fr_window_resize_tl(inputs)
	if (locale === "pt") return pt_window_resize_tl(inputs)
	if (locale === "zh") return zh_window_resize_tl(inputs)
	if (locale === "tr") return tr_window_resize_tl(inputs)
	if (locale === "ru") return ru_window_resize_tl(inputs)
	if (locale === "pl") return pl_window_resize_tl(inputs)
	return en_window_resize_tl(inputs)
});